import Event from './Event';

/**
 * このアプリケーションで汎用的に使用されるカスタムイベント
 */
export default class AppEvent extends Event {
	/* 表示時 */
	static SHOW: string = 'onShow';
	/* 非表示時 */
	static HIDE: string = 'onHide';
	/* ボタンクリック */
	static CLICK: string = 'onClick';
	/* コンテンツのクローズ時 */
	static CLOSE: string = 'onClose';
	/* コンテンツのオープン時 */
	static OPEN: string = 'onOpen';
	/* コンテンツの終了時 */
	static END: string = 'onEnd';
	/* コンテンツのロード途中時 */
	static LOAD_PROGRESS: string = 'onLoadProgress';
	/* コンテンツのロード完了時 */
	static LOAD_COMPLETE: string = 'onLoadComplete';
	/* 再生時間の更新 */
	static TIME_UPDATE: string = 'onTimeUpdate';
	
	public data: any;
	public buffered: number;

	/**
	 * コンストラクタ
	 * @param {string} type
	 * @param {boolean} bubbles
	 * @param {boolean} cancelable
	 */
	constructor(type:string, bubbles:boolean = null, cancelable:boolean = null) {
		super(type, bubbles, cancelable);
	}
}
